import { SaveOpeningBalanceModel } from '@app/core/Models';
import { Guid } from 'guid-typescript';

export class RefreshAccountProductionTrialBalance {
  static readonly type =
    '[ACCOUNTPRODUCTION] Refresh Account Production Trial Balance ';

  constructor(public accountingPeriodId: Guid) {}
}

export class GetAccountProductionTrialBalance {
  static readonly type =
    '[ACCOUNTPRODUCTION] Get Account Production Trial Balance ';

  constructor(public accoutingPeriodId: Guid) {}
}

export class SaveAccountProductionTrialBalance {
  static readonly type = '[ACCOUNTPRODUCTION] save Trial Balance';

  constructor(public trialBalance: SaveOpeningBalanceModel) {}
}
export class GetAccountProductionTrialBalanceByJurnId {
  static readonly type =
    '[ACCOUNTPRODUCTION] Get Account Production Trial Balance By Jurnal ID ';

  constructor(public jurnalId: Guid) {}
}

export class GetAllJournalsBasedOnAccountingPeriodId {
  static readonly type =
    '[ACCOUNTPRODUCTION] Get Account Production Jurnals By Jurnal ID ';

  constructor(public periodId: Guid) {}
}
export class DeleteTBJurnal {
  static readonly type =
    '[ACCOUNTPRODUCTION] Delete TB Jurnals By Jurnal ID ';

  constructor(public jurnalId: Guid) {}
}

export class GetAutoRoundingSettingAccounts {
  static readonly type =
    '[ACCOUNTPRODUCTION] Get Auto Rounding Setting Accounts';
}

export class SaveAutoRoundingSetting {
  static readonly type = '[ACCOUNTPRODUCTION] Save Auto Rounding Setting';
  constructor(public payload: any) {}
}

export class GetAutoRoundingSettingList {
  static readonly type = '[ACCOUNTPRODUCTION] Get Auto Rounding Setting List';
}

export class GetAutoRoundingSettingById {
  static readonly type = '[ACCOUNTPRODUCTION] Get Auto Rounding Setting By Id';
  constructor(public id: string) {}
}

export class UpdateAutoRoundingSetting {
  static readonly type = '[ACCOUNTPRODUCTION] Update Auto Rounding Setting';
  constructor(public id: string, public payload: any) {}
}

export class DeleteAutoRoundingSetting {
  static readonly type = '[ACCOUNTPRODUCTION] Delete Auto Rounding Setting';
  constructor(public id: string) {}
}

export class GetAutoRoundingCompanySetting {
  static readonly type = '[ACCOUNTPRODUCTION] Get Auto Rounding Company Setting';
}

export class UpdateAutoRoundingCompanySetting {
  static readonly type = '[ACCOUNTPRODUCTION] Update Auto Rounding Company Setting';
  constructor(public isAutoRounding: boolean) {}
}